<div *ngIf="!hideMap" #mapContainer>
  <curbnturf-open-street-map
    #openStreetMap
    [lat]="coordinates.lat"
    [lon]="coordinates.lon"
    [zoom]="zoom"
    [mapHostPoints]="points"
    [mapBoondockPoints]="boondockPoints"
    [mapPoiPoints]="activities ?? []"
    [disableControls]="true"
  >
  </curbnturf-open-street-map>
</div>
